import { defineMessages } from 'react-intl-next';

export const messages: {
    agentsHeader: {
        id: string;
        defaultMessage: string;
        description: string;
    }; browseAgents: {
        id: string;
        defaultMessage: string;
        description: string;
    }; createAgent: {
        id: string;
        defaultMessage: string;
        description: string;
    };
} = defineMessages({
	agentsHeader: {
		id: 'ai-mate.chat-input.agents.header',
		defaultMessage: 'Start chatting with agents',
		description: 'Heading text for the agents section in the chat input actions menu',
	},
	browseAgents: {
		id: 'ai-mate.chat-input.agents.browse-agents',
		defaultMessage: 'Browse agents',
		description: 'Text for the browse agents button in the chat input actions menu',
	},
	createAgent: {
		id: 'ai-mate.chat-input.agents.create-agent',
		defaultMessage: 'Create agent',
		description: 'Text for the create agent button in the chat input actions menu',
	},
});
